import React from 'react';

class LoadingPage extends React.Component {

    render() {
        // localStorage.removeItem('recordId');
        // localStorage.removeItem('recordId2');
        return (
            <div>Loading...</div>
        );
    }
}

export default LoadingPage;



// WEBPACK FOOTER //
// ./src/js/components/app/LoadingPage.js